import { render, staticRenderFns } from "./BaseModalContent.vue?vue&type=template&id=6c1bb394&scoped=true&"
import script from "./BaseModalContent.vue?vue&type=script&lang=js&"
export * from "./BaseModalContent.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalContent.vue?vue&type=style&index=0&id=6c1bb394&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1bb394",
  null
  
)

export default component.exports